import { render, staticRenderFns } from "./InstagramFilter.vue?vue&type=template&id=05683294&scoped=true"
import script from "./InstagramFilter.vue?vue&type=script&lang=js"
export * from "./InstagramFilter.vue?vue&type=script&lang=js"
import style0 from "./InstagramFilter.vue?vue&type=style&index=0&id=05683294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05683294",
  null
  
)

export default component.exports